// components/DialogConfirmacion.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const DialogConfirmacion = ({
  open,
  onClose,
  onConfirm,
  selectedItems,
  datosActuales,
  updating,
}) => {
  // Obtener los datos de los items seleccionados (solo los no conciliados)
  const getSelectedData = () => {
    const items = [];
    Object.keys(selectedItems).forEach(key => {
      if (selectedItems[key]) {
        const index = parseInt(key.split('-')[1]);
        const item = datosActuales[index];
        if (item) {
          const dbData = item.db || item;
          // Solo incluir si no está conciliado
          if (dbData?.conciliado !== 1) {
            items.push(dbData);
          }
        }
      }
    });
    return items;
  };

  const selectedData = getSelectedData();
  const totalMonto = selectedData.reduce((sum, item) => sum + (parseFloat(item.monto) || 0), 0);

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CheckCircleIcon color="success" />
        Confirmar Conciliación
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText>
          ¿Estás seguro que deseas marcar como conciliados los siguientes {selectedData.length} pagos?
        </DialogContentText>
        
        <Box sx={{ mt: 2, mb: 1 }}>
          <Typography variant="subtitle2" color="textSecondary">
            Resumen:
          </Typography>
          <Box sx={{ display: 'flex', gap: 3, mt: 1, flexWrap: 'wrap' }}>
            <Box>
              <Typography variant="caption" color="textSecondary">
                Total de pagos
              </Typography>
              <Typography variant="h6">{selectedData.length}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="textSecondary">
                Monto total
              </Typography>
              <Typography variant="h6" sx={{ color: '#ed6c02' }}>
                ${totalMonto.toFixed(2)}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ mt: 2, maxHeight: 300, overflow: 'auto', border: '1px solid #e0e0e0', borderRadius: 1 }}>
          {selectedData.map((item, idx) => (
            <Box 
              key={idx} 
              sx={{ 
                py: 1, 
                px: 2, 
                borderBottom: idx < selectedData.length - 1 ? '1px solid #f0f0f0' : 'none',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '&:hover': { bgcolor: '#f5f5f5' }
              }}
            >
              <Box>
                <Typography variant="body2">
                  <strong>Pedido:</strong> {item.pedido}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {item.cliente}
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                ${parseFloat(item.monto).toFixed(2)}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={onClose} 
          disabled={updating}
          variant="outlined"
          color='error'
        >
          Cancelar
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="success"
          disabled={updating || selectedData.length === 0}
          startIcon={updating ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
        >
          {updating ? 'Conciliando...' : `Confirmar (${selectedData.length})`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmacion;